export type Bounds = {
  width: number;
  height: number;
};

export default function getContentBoxSize(
  targetElement: Element,
  entry?: ResizeObserverEntry,
): Bounds {
  if (entry?.contentRect) {
    return {
      width: entry.contentRect.width,
      height: entry.contentRect.height,
    };
  }

  if (targetElement instanceof HTMLElement) {
    const style = window.getComputedStyle(targetElement);
    const paddingX =
      parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
    const paddingY =
      parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    const width = targetElement.clientWidth - paddingX;
    const height = targetElement.clientHeight - paddingY;

    if (Number.isFinite(width) && Number.isFinite(height)) {
      return {
        width: Math.max(0, width),
        height: Math.max(0, height),
      };
    }
  }

  const rect = targetElement.getBoundingClientRect();
  return { width: rect.width, height: rect.height };
}
